import React, {Component} from 'react'
import propTypes from 'prop-types'
import Hint from 'components/hint'
import {prefix} from 'helpers/component'

class Hintable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      anchor: null,
    }
    this.getClass = prefix('hintable-')
  }

  show = (e) => {
    const {delayed, delay} = this.props
    const anchor = e.currentTarget

    if (delayed) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        this.setState({
          visible: true,
          anchor,
        })
      }, delay)
    } else {
      this.setState({
        visible: true,
        anchor,
      })
    }
  }

  hide = () => {
    this.setState({visible: false, anchor: null})
    if (this.timer) clearTimeout(this.timer)
  }

  render() {
    const {
      active,
      children,
      light,
      style,
      ...hintProps
    } = this.props
    const {anchor, visible} = this.state

    return active
      ? <div
        className={this.getClass('container')}
        style={style}
        onMouseOver={this.show}
        onMouseLeave={this.hide}
      >
        <Hint
          {...hintProps}
          anchor={anchor}
          visible={visible}
          light={light}
        />
        {children}
      </div>
      : children
  }
}

Hintable.propTypes = {
  active: propTypes.bool,
  label: Hint.propTypes.label,
  small: Hint.propTypes.small,
  animated: Hint.propTypes.animated,
  light: Hint.propTypes.light,
  delayed: propTypes.bool,
  delay: propTypes.number,
  children: propTypes.any.isRequired,
  style: propTypes.object,
  tooltip: propTypes.bool,
  width: propTypes.number,
  hasPointer: propTypes.bool,
}

Hintable.defaultProps = {
  active: true,
  small: false,
  animated: true,
  delayed: false,
  delay: 500,
}

export default Hintable
